export default "__VITE_ASSET__BRvSdyUD__"